import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u82F1\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted, nextTick, reactive, toRefs } from 'vue';
import { getHomeCorporateAdvantageList_url } from '@/api'; //引入发送请求获取数据的方法

import { useRouter, useRoute } from "vue-router";
export default {
  name: 'Advantage',
  setup: function setup() {
    var pordetail = ref({}); //获取企业优势单个显示对象

    var porateAdvantageList = ref([]); //获取企业优势列表

    function getHomeCorporateAdvantageList() {
      return _getHomeCorporateAdvantageList.apply(this, arguments);
    }

    function _getHomeCorporateAdvantageList() {
      _getHomeCorporateAdvantageList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getHomeCorporateAdvantageList_url();

              case 2:
                result = _context.sent;

                if (result.code == 200) {
                  pordetail.value = result.data[2];
                  porateAdvantageList.value = result.data;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getHomeCorporateAdvantageList.apply(this, arguments);
    }

    onMounted(function () {
      getHomeCorporateAdvantageList();
    });
    var roundIndex = ref(3); //默认显示第3个
    //切换事件

    function roundClick(index) {
      roundIndex.value = index; // console.log('roundIndex=', roundIndex.value)

      pordetail.value = porateAdvantageList.value[roundIndex.value - 1]; // console.log('pordetail=', pordetail.value)
    }

    var router = useRouter();
    var route = useRoute();

    var jumpMore = function jumpMore() {
      router.push({
        path: '/aboutUs',
        hash: '#advantage'
      });
    };

    return {
      porateAdvantageList: porateAdvantageList,
      pordetail: pordetail,
      roundIndex: roundIndex,
      roundClick: roundClick,
      jumpMore: jumpMore
    };
  }
};